import React from "react";

export default ({ data }) => (
  <div className="card w-full m-1 py-3 md:py-4 px-3 md:px-4 flex flex-row items-center">
    <div className="w-6 h-6 md:w-8 md:h-8 m-1 md:m-2 mr-3 md:mr-4 flex-shrink-0">
      <svg
        className={`fill-current w-6 h-6 md:w-8 md:h-8 ${data.type}`}
        xmlns="http://www.w3.org/2000/svg"
        height="1em"
        viewBox="0 0 512 512"
      >
        {data.type === "positive" ? (
          <path d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z" />
        ) : null}
        {data.type === "negative" ? (
          <path d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z" />
        ) : null}
        {["neutral", "ongoing"].includes(data.type) ? (
          <path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z" />
        ) : null}
      </svg>
    </div>
    <div className="flex flex-col min-w-0">
      <h3 className="text-xs md:text-sm text-left">{data.text}</h3>
      <p className="text-base md:text-lg text-left break-words">{data.value}</p>
    </div>
  </div>
);
